/* GAP configurator add-on, loaded by the Custom Liquid section in templates/page.gap-configurator.json. Paper groups:
   the paper sheet shows two groups, Photo papers and Fine Art papers, with the papers of the chosen group below
   (the same names as the paper guide). Groups come from the paper names, so new papers fall into place without code
   changes. Papers in the full list that a product has no variant for yet are shown greyed out as "Coming soon". */
(function () {
  var GROUPS = [
    ['photo', 'Photo papers', 'Luster, gloss, matt'],
    ['fineart', 'Fine Art papers', 'Cotton rag & baryta']
  ];
  function groupOf(name) {
    var n = name.toLowerCase();
    if (/lust(er|re)|photo\s*gloss|matt?\s*fib|titanium/.test(n)) return 'photo';
    if (/rag|etching|baryta|bamboo|metallic|fine\s*art/.test(n)) return 'fineart';
    return null;
  }
  /* the full paper list per product, shown even before every paper has a variant */
  var FULL = {
    'Photo & Fine Art Print': ['HM Photo Luster 260gsm', 'HM Photo Gloss 260gsm', 'HM Photo Matt Fibre 200gsm', 'Permajet Titanium Gloss 300gsm']
  };
  function placeholders(cards, list, p) {
    var want = FULL[p] || [], names = list.map(function (c) { var b = c.querySelector('b'); return b ? b.textContent.trim() : ''; });
    want.forEach(function (n) {
      if (names.indexOf(n) > -1) return;
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'gapcfg__card gapcfg__card--soon'; c.disabled = true; c.setAttribute('aria-disabled', 'true');
      c.innerHTML = '<b>' + n + '</b><span>Coming soon</span>';
      cards.appendChild(c); list.push(c);
    });
  }
  function q(s) { return document.querySelector(s); }
  var active = null, prod = '', lastSel = '';
  function papers(cards) { return [].filter.call(cards.children, function (c) { return c.classList.contains('gapcfg__card'); }); }
  function run() {
    var title = q('[data-gapcfg] [data-sheettitle]'), cards = q('[data-gapcfg] [data-cards]');
    if (!title || !cards) return;
    var bar = q('.gapcfg__pgroups');
    var p = (q('[data-gapcfg] [data-title]') || {}).textContent || '';
    if (p !== prod) { prod = p; active = null; lastSel = ''; }
    var list = papers(cards), map = {};
    var isPaper = /paper/i.test(title.textContent) && !cards.hidden;
    if (isPaper) placeholders(cards, list, p.trim());
    if (isPaper) list.forEach(function (c) {
      var b = c.querySelector('b'), g = b && groupOf(b.textContent);
      if (c.getAttribute('data-pg') !== (g || '')) c.setAttribute('data-pg', g || '');
      if (g) (map[g] = map[g] || []).push(c);
    });
    var have = GROUPS.filter(function (g) { return map[g[0]]; });
    var grouped = isPaper && have.length >= 2;
    if (cards.hasAttribute('data-grouped') !== grouped) { if (grouped) cards.setAttribute('data-grouped', ''); else cards.removeAttribute('data-grouped'); }
    if (!grouped) { if (bar && !bar.hidden) bar.hidden = true; return; }
    list.forEach(function (c) { var b = c.querySelector('b'); if (b && /^Hahnem[uü]hle\s/i.test(b.textContent)) b.textContent = b.textContent.replace(/^Hahnem[uü]hle\s/i, 'HM '); });
    var sel = list.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })[0];
    var sn = sel ? sel.textContent : '';
    if (sn && sn !== lastSel) { lastSel = sn; active = sel.getAttribute('data-pg') || active; }
    if (!active || !map[active]) active = (sel && sel.getAttribute('data-pg')) || have[0][0];
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'gapcfg__pgroups'; bar.setAttribute('role', 'radiogroup'); bar.setAttribute('aria-label', 'Paper type');
      bar.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('button');
        if (!t) return;
        active = t.getAttribute('data-g');
        var m = papers(q('[data-gapcfg] [data-cards]')).filter(function (c) { return c.getAttribute('data-pg') === active; });
        if (m.length === 1 && m[0].getAttribute('aria-checked') !== 'true') m[0].click();
        run();
      });
    }
    if (bar.nextElementSibling !== cards) cards.parentNode.insertBefore(bar, cards);
    var key = have.map(function (g) { return g[0]; }).join(',');
    if (bar.getAttribute('data-k') !== key) {
      bar.setAttribute('data-k', key);
      bar.innerHTML = have.map(function (g) { return '<button type="button" role="radio" data-g="' + g[0] + '"><b>' + g[1] + '</b><small>' + g[2] + '</small></button>'; }).join('');
    }
    [].forEach.call(bar.children, function (b) { var v = String(b.getAttribute('data-g') === active); if (b.getAttribute('aria-checked') !== v) b.setAttribute('aria-checked', v); });
    if (bar.hidden) bar.hidden = false;
    list.forEach(function (c) { var d = c.getAttribute('data-pg') === active ? '' : 'none'; if (c.style.display !== d) c.style.display = d; });
  }
  var css = document.createElement('style');
  css.textContent = '[data-gapcfg] .gapcfg__card--soon{opacity:.45;cursor:not-allowed}'
    + '[data-gapcfg] .gapcfg__cards[data-paper][data-grouped] .gapcfg__card b{white-space:normal!important;overflow:visible!important;text-overflow:clip!important;line-height:1.2}'
    + '.gapcfg__pgroups{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:5px;margin:0 0 8px}'
    + '.gapcfg__pgroups[hidden]{display:none}'
    + '[data-gapcfg] .gapcfg__cards[data-paper][data-grouped]{grid-template-columns:repeat(3,minmax(0,1fr))!important}'
    + '[data-gapcfg] .gapcfg__cards[data-paper][data-grouped] .gapcfg__card,[data-gapcfg] .gapcfg__cards[data-paper][data-grouped] .gapcfg__card b{font-size:12px!important}'
    + '.gapcfg__pgroups button{appearance:none;border:1.5px solid #E0DDD8;background:#fff;color:#1E1B18;border-radius:4px;padding:6px 2px;font-family:inherit;line-height:1.15;cursor:pointer;text-align:center}'
    + '.gapcfg__pgroups b{display:block;font-size:12px;font-weight:700}'
    + '.gapcfg__pgroups small{display:block;font-size:10px;opacity:.7;margin-top:2px}'
    + '.gapcfg__pgroups button[aria-checked=true]{background:#C8401A;border-color:#C8401A;color:#fff}'
    + '.gapcfg__pgroups button[aria-checked=true] small{opacity:.9}';
  document.head.appendChild(css);
  function start() {
    var g = q('[data-gapcfg]');
    if (!g) return false;
    new MutationObserver(run).observe(g, { childList: true, subtree: true, characterData: true });
    run();
    return true;
  }
  if (!start()) document.addEventListener('DOMContentLoaded', start);
})();
